// extracted by mini-css-extract-plugin
module.exports = {"loginBtn":"styles_loginBtn__2D4Ix","widthFull":"styles_widthFull__1tfH-","widthAuto":"styles_widthAuto__16NKD","header":"styles_header__7dov3"};